// @flow
import React, { useLayoutEffect, type ComponentType } from "react";
import { useSelector, useDispatch, Dispatch } from "react-redux";
import Constants, { getDisplayName } from "data/constants";
import { type docsLayoutState } from "data/reducers/types";
import {
    requestDocsLayoutAction,
    ensureDocsLayoutReloadingAction,
} from "data/actions";
import Status from "components/Status";
import { docsLayoutSelector } from "data/reducers/selectors";

type Props = {
    itemUri: string,
    formatId: string,
    showDocs?: boolean,
};

// will block until docsLayout is OK and pass it on as a layout prop
const LayoutLoader = (WrappedComponent: ComponentType<any>) => {
    const HOC = (props) => {
        const { itemUri, formatId = null, showDocs = true } = props;
        const layout: docsLayoutState = useSelector(docsLayoutSelector);
        const dispatch: Dispatch = useDispatch();
        useLayoutEffect(() => {
            if (formatId == null) return;
            dispatch(
                requestDocsLayoutAction(itemUri, formatId, showDocs === false)
            );
            return () => dispatch(ensureDocsLayoutReloadingAction());
        }, [itemUri, formatId]);
        if (layout.status === Constants.OK)
            return <WrappedComponent {...props} layout={layout} />;
        if (layout.status === Constants.ERROR)
            return <Status status={Constants.ERROR} />;
        return <Status status={Constants.LOADING} />;
    };
    HOC.displayName = `LayoutLoader(${getDisplayName(WrappedComponent)})`;
    return HOC;
};

export default LayoutLoader;
